<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label
      v-if="label"
      :class="required ? 'required' : ''"
    >
      {{ label }}
    </label>

    <VueDatePicker
      v-model="model"
      format="dd MMM yyyy"
      :flow="['calendar']"
      :max-date="maxDate"
      model-type="iso"
      :hide-navigation="['month', 'year', 'calendar', 'time', 'minutes', 'hours', 'seconds']"
      :clearable="clearable"
      auto-apply
      timezone="Africa/Johannesburg"
      :range="range"
      :preset-dates="presetDates"
    >
      <template
        v-if="iconOnly"
        #trigger
      >
        <AppButton>
          <FontAwesomeIcon
            class="min-width"
            :icon="faCalendar"
          />
        </AppButton>
      </template>
    </VueDatePicker>

    <span
      v-if="validationError"
      class="validation-error-message absolute -bottom-5"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
import VueDatePicker from '@vuepic/vue-datepicker';

import { AppButton } from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

const model = defineModel();

// If we want to set a maxDate we can add this. We can do it on the component where we want to have a max date and pass it as a prop.
// import { useDayjs } from '@/composables';
// const dayjs = useDayjs();
// const maxDate = dayjs().endOf('day').toDate();

defineProps({
  validationError: {
    type: [Boolean, String],
    default: null,
  },
  maxDate: {
    type: [Date, String],
    default: null,
  },
  presetDates: {
    type: Array,
    default: () => [],
  },
  range: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  iconOnly: {
    type: Boolean,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
});
</script>
